var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuthGoogle = function SvgAuthGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "M15.237 7.378q-.002-.745-.134-1.432H8.145v2.708h3.976c-.172.875-.692 1.616-1.475 2.112v1.756h2.388c1.397-1.218 2.203-3.012 2.203-5.144",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "evenodd",
    d: "M8.141 14.218c1.995 0 3.668-.626 4.89-1.695l-2.388-1.757c-.661.42-1.508.668-2.502.668-1.924 0-3.553-1.23-4.134-2.885H1.54v1.813c1.216 2.288 3.714 3.856 6.602 3.856",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    fillRule: "evenodd",
    d: "M4.012 8.547a4 4 0 0 1-.232-1.33c0-.46.084-.91.232-1.33V4.075H1.544a6.7 6.7 0 0 0-.786 3.144c0 1.129.285 2.198.786 3.143z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    fillRule: "evenodd",
    d: "M8.141 3.002c1.085 0 2.059.353 2.825 1.046l2.119-2.007C11.805.91 10.133.218 8.14.218c-2.888 0-5.386 1.568-6.602 3.856l2.468 1.813c.581-1.654 2.21-2.885 4.134-2.885",
    clipRule: "evenodd"
  })));
};
export default SvgAuthGoogle;